<template>
  <div class="side-menu nav-menu flex-column" :class="{ 'nav-expanded': app.navbarExpanded }" style="position:relative">
    <el-dialog :visible.sync="showLinkDownload" width="760px" append-to-body :close-on-click-modal="false">
      <DownLoadApp />
    </el-dialog>
    <!-- LOGO -->


    <div class="flex-lg-column mt-3">
      <ul class="nav nav-pills side-menu-nav justify-content-center" role="tablist">
        <el-popover class="px-3" placement="right" trigger="click">
          <iframe id="app-salework-frame" src="https://salework.net/frame/app-salework"
                  style="width: 425px;  min-height: 445px; background-color: transparent; border-radius: 5px; border: none;"></iframe>
          <li class="nav-item mb-2" slot="reference" data-bs-toggle="tooltip" data-bs-placement="top"
              data-bs-original-title="Profile">

            <a
              class="nav-link text-center"
              data-bs-toggle="pill"
              role="tab"
              v-bind:class="app.navbarExpanded?'active':''"
            >
              <div class="d-flex py-2 "
                   v-bind:class="!app.navbarExpanded?'justify-content-center':'justify-content-start'">
                <el-avatar class="company-avatar" :size="32" :src="getCompanyAvatar()"></el-avatar>

                <div class="company-name flex-grow-" v-if="app.navbarExpanded">
                  <div class=" fw-semibold">{{ getCompanyName() }}</div>
                  <div>{{ getCompanyAlias() }}</div>
                </div>
              </div>
            </a>
          </li>
        </el-popover>
        <router-link to="/conversation" class="pointer">
          <li id="v-step-0" class="nav-item" data-bs-toggle="tooltip" data-bs-placement="top"
              data-bs-original-title="Profile">
            <el-tooltip content="Danh sách tin nhắn" placement="right" effect="dark">
              <a
                class="nav-link "
                id="pills-user-tab"
                data-bs-toggle="pill"
                role="tab"
                v-bind:class="this.$route.path == '/conversation' || this.$route.path == '/' ? 'active' : ''"
              >

                <img src="/assets/images/ic_mes.svg" />
                <span class="nav-title">Danh sách tin nhắn</span>

              </a>
            </el-tooltip>
          </li>
        </router-link>
        <router-link to="/statistical" class="pointer" v-if="isAdminUser()">
          <li id="v-step-8" class="nav-item" data-bs-toggle="tooltip" data-bs-placement="top"
              data-bs-original-title="Profile">
            <el-tooltip content="Báo cáo thống kê" placement="right" effect="dark">
              <a
                class="nav-link "
                id="pills-user-tab-2"
                data-bs-toggle="pill"
                role="tab"
                v-bind:class="this.$route.path == '/statistical'  ? 'active' : ''"
              >

                <img src="/assets/images/ic_dashboard.svg" />
                <span class="nav-title">Báo cáo thống kê</span>

              </a>
            </el-tooltip>
          </li>
        </router-link>

        <router-link to="/contact" class="pointer">
          <li class="nav-item" id="v-step-1" data-bs-toggle="tooltip" data-bs-placement="top"
              data-bs-original-title="Profile" v-if="isContactUser()">
            <el-tooltip content="Danh bạ" placement="right" effect="dark">
              <a
                class="nav-link"
                id="pills-groups-tab"
                data-bs-toggle="pill"
                role="tab"
                v-bind:class="this.$route.path == '/contact' ? 'active' : ''"
              >

                <img src="/assets/images/ic_per.svg" />
                <span class="nav-title">Danh bạ</span>

              </a>
            </el-tooltip>
          </li>
        </router-link>




        <router-link to="/setting" class="pointer">
          <li class="nav-item" id="v-step-3" v-if="isAdminUser()">
            <el-tooltip content="Thiết lập" placement="right" effect="dark">
              <a
                class="nav-link"
                data-bs-toggle="tooltip"
                data-bs-trigger="hover"
                data-bs-placement="right"
                title="Thiết lập"
                data-bs-original-title="Dark / Light Mode"
                v-bind:class="this.$route.path == '/v2/setting' ? 'active' : ''"
              >

                <img src="/assets/images/ic_setting.svg" />
                <span class="nav-title">Thiết lập</span>

              </a>
            </el-tooltip>
          </li>
        </router-link>

        <li class="nav-item" id="v-step-4">
          <el-tooltip content="Hỗ trợ trực tuyến" placement="right" effect="dark">
            <a
              class="nav-link"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="right"
              title=""
              data-bs-original-title="Dark / Light Mode"
            >
              <a href="https://m.me/110612267506958" target="_blank">
                <img src="/assets/images/ic_call.svg" />
                <span class="nav-title">Hỗ trợ trực tuyến</span>
              </a>
            </a>
          </el-tooltip>
        </li>
        <li class="nav-item">
          <el-tooltip content="Hướng dẫn sử dụng" placement="right" effect="dark">
            <a
              class="nav-link"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-placement="right"
              title=""
              data-bs-original-title="Dark / Light Mode"
            >
              <a href="https://docs.salework.net/v/salework-zalo" target="_blank" class="fw-bold">
                <img src="/assets/images/ic_doc.svg" />
                <span class="nav-title">Hướng dẫn sử dụng</span>
              </a>
            </a>
          </el-tooltip>
        </li>

      </ul>
    </div>
    <div style="position: absolute; bottom: 60px; right:-20px ">
      <div class="rounded-circle align-items-center  expand-btn" @click="expandTogle()">
        <div class="font-weight-bold "
             :class="{ 'el-icon-arrow-left': app.navbarExpanded, 'el-icon-arrow-right': !app.navbarExpanded }" />
      </div>
    </div>
    <div v-if="app.navbarExpanded" class="download-app-box pointer" @click="showPopDownload()">
      <div class="d-flex pointer">
        <el-image class="logo-salework" src="/assets/images/salework.png" fit="contain" />
        <div class="font-size-13 fw-bold text-gray">Tải Salework app</div>
      </div>
    </div>
    <div>
      <v-tour name="myTour" :steps="steps" :options="myOptions" :callbacks="callbacks"></v-tour>
    </div>
  </div>
</template>

<script>
import DownLoadApp from "../components/DownLoadApp";

export default {
  components: {
    DownLoadApp
  },
  methods: {

    getCompanyAvatar() {
      return "https://salework.net/storage/image/" + this.app.user.companyAvatar;
    },
    getCompanyName() {
      return this.app.user.companyName;
    },
    getCompanyAlias() {
      return "@" + this.app.user.companyAlias;
    },
    expandTogle() {
      this.app.navbarExpanded = !this.app.navbarExpanded;
    },

    closeStep() {
      this.app.isSkipTour = true;
      localStorage.setItem("showTour", true);
      this.checkShopExpired();
    },
    showPopDownload() {
      this.showLinkDownload = true;
    }
  },
  data() {
    return {
      showLinkDownload: false,
      callbacks: {
        onSkip: this.closeStep,
        onStop: this.closeStep
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Bỏ qua hướng dẫn",
          buttonPrevious: "Trước",
          buttonNext: "Tiếp",
          buttonStop: "Kết thúc"
        },
        highlight: true
      },
      steps: [
        {
          target: "#v-step-0",
          // We're using document.querySelector() under the hood
          header: {
            title: "Danh sách tin nhắn"
          },
          content: `Giúp bạn quản lý toàn bộ tin nhắn của các tài khoản đã được liên kết.`,
          params: {
            placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },

        {
          target: "#v-step-3",
          header: {
            title: "Thiết lập"
          },
          content: "Các bạn có thể thêm tài khoản Zalo, cài đặt Tag, Thư viện hình ảnh, tin nhắn mẫu và nhiều thiết lập khác tại đây.",
          params: {
            placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: "#v-step-4",
          content: "Chat với nhân viên hỗ trợ",
          params: {
            placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        }
      ]
    };
  },
  mounted: function() {
    // if (!localStorage.getItem("showTour")) {
    //   this.$tours["myTour"].start();
    //   this.app.isSkipTour = false;
    // } else {
    this.app.isSkipTour = true;
    // }
  }
};
</script>

<style>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
}
</style>
